<template>
  <img class="off" src="/public/icons/conference-off.svg" alt="" />
  <img class="on" src="/public/icons/conference-on.svg" alt="" />
</template>

<script>
export default {
  name: 'IconUserVoice',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
